import {PlayerCategory} from "data/enums";
import {IGamePlayer} from "data/utils/player.calculations";

export abstract class SquadUtils {
	public static buildCSSVarBackground(player?: Partial<IGamePlayer>, withCold: boolean = true) {
		const abbr = player?.squad?.abbreviation ?? "";
		const isCold = player?.contestStats?.category === PlayerCategory.COLD;

		if (isCold && withCold) {
			return `var(--cold-gradient), var(--${abbr}-background, #000);`;
		}

		return `var(--${abbr}-background, #000);`;
	}
}
